import { BoxProps, CircularProgress } from '@mui/material'
import * as React from 'react'
import { CenteredBox, CoverBox } from '../elements/basic-elements'
const LoadingOverlay: React.FC<
  BoxProps & {
    loading: boolean
    scheme?: 'dark' | 'light'
    hideBackground?: boolean
    color?: string
  }
> = ({ loading, color, scheme = 'dark', hideBackground, ...boxProps }) => {
  return (
    <CoverBox
      sx={{
        opacity: loading ? 1 : 0,
        pointerEvents: loading ? 'all' : 'none',
        color: scheme == 'dark' ? '#fff' : '#000',
        backgroundColor: hideBackground
          ? 'rgba(0,0,0,0)'
          : scheme == 'dark'
            ? 'rgba(0,0,0,0.5)'
            : 'rgba(255,255,255,0.5)',
        position: 'absolute',
        zIndex: theme => theme.zIndex.drawer + 1,
        transition: `opacity 0.1s linear`,
        ...boxProps.sx
      }}
    >
      <CenteredBox>
        <CircularProgress sx={{ color: color || 'inherit' }} />
      </CenteredBox>
    </CoverBox>
  )
}

export default LoadingOverlay
